// @ts-nocheck
import { createReducer } from 'Helpers/redux'
import {
  SpotifyCampaign,
  TiktokCampaign,
  DetailsTiktok,
  EventsTiktok,
  EventsTiktokStatuses,
  CampaignToSchedule,
  CampaignPlatformTypeEnum,
  CampaignStatusEnum,
  CampaignTypeEnum,
} from 'Types/index'
import {
  ADD_NEW_CAMPAIGN,
  ADD_NEW_TIK_TOK_CAMPAIGN,
  GET_CAMPAIGNS_LIST,
  SCHEDULE_CAMPAIGN,
  CHECK_TRACK_TO_CREATE_CAMPAIGN,
  RENEW_CAMPAIGN,
  GET_PRESCHEDULE_PRICE,
  GET_ARTIST_SPOTIFY_CONNECTIONS,
  SET_SPOTIFY_CONNECTION_FOR_ARTIST,
  CREATE_RELAUNCH_CAMPAIGN,
  GET_TIKTOK_CAMPAIGN_DETAILS,
  GET_TIKTOK_CAMPAIGN_EVENTS,
  POST_TIKTOK_CAMPAIGN_EVENT_REJECT,
  // PUT_TIKTOK_CAMPAIGN_EVENT_RATE,
  GET_ALL_CAMPAIGNS,
  GET_CAMPAIGNS_TIKTOK_LIST,
  GET_TIKTOK_CAMPAIGN_EVENTS_STATUSES,
  SET_CAMPAIGNS,
  GET_CAMPAIGN_STATUS,
} from '../actions/campaignActions'
import {
  CHANGE_CAMPAIGN,
  CHANGE_CAMPAIGN_GENRE,
} from '../actions/scheduleActions'

export type CampaignsState = {
  error: unknown
  campaigns: Array<SpotifyCampaign | TiktokCampaign>
  preschedule: { playlists: number; price: number }
  loading: boolean
  connections: []
  detailsTiktok: DetailsTiktok | Record<string, never>
  eventsTiktok: EventsTiktok
  eventsTiktokStatuses: EventsTiktokStatuses | Record<string, never>
  tiktokCancel: unknown
  sfa_email: string
  amountOfCampaigns: number
  campaignToSchedule: {
    campaign: CampaignToSchedule
  }
}

const initialState: CampaignsState = {
  error: null,
  campaigns: [],
  preschedule: { playlists: 0, price: 0 },
  loading: false,
  connections: [],
  detailsTiktok: {},
  eventsTiktok: {},
  eventsTiktokStatuses: {},
  tiktokCancel: {},
  sfa_email: null,
  amountOfCampaigns: 0,
}

const handlers = {
  [GET_TIKTOK_CAMPAIGN_EVENTS_STATUSES.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    eventsTiktokStatuses: payload,
  }),
  [GET_TIKTOK_CAMPAIGN_DETAILS.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    detailsTiktok: payload,
  }),
  [GET_TIKTOK_CAMPAIGN_EVENTS.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    eventsTiktok: payload,
  }),
  [POST_TIKTOK_CAMPAIGN_EVENT_REJECT.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    tiktokReject: [...prevState.tiktokCancel, payload],
  }),
  [GET_CAMPAIGNS_LIST.REQUEST]: prevState => ({
    ...prevState,
    loading: prevState.campaigns.length === 0,
  }),
  [GET_CAMPAIGNS_TIKTOK_LIST.REQUEST]: prevState => ({
    ...prevState,
    loading: false,
  }),
  [ADD_NEW_CAMPAIGN.REQUEST]: prevState => ({
    ...prevState,
    loading: true,
  }),
  [ADD_NEW_CAMPAIGN.SUCCESS]: (
    prevState: CampaignsState,
    {
      payload,
    }: {
      Track: { track_image: string; artist_name: string; track_name: string }
      end_date: string | null
      id: number
      start_date: string | null
      status: CampaignStatusEnum
      type: CampaignTypeEnum
    }
  ): CampaignsState => ({
    ...prevState,
    loading: false,
    campaigns: [
      {
        id: payload.id,
        type: payload.type,
        trackCoverUrl: payload.Track.track_image,
        trackTitle: payload.Track.track_name,
        trackAuthorName: payload.Track.artist_name,
        startDate: payload.start_date,
        endDate: payload.end_date,
        status: payload.status,
        is_feed: payload.is_feed,
        platformType: CampaignPlatformTypeEnum.SPOTIFY,
      },
      ...prevState.campaigns,
    ],
  }),
  [ADD_NEW_TIK_TOK_CAMPAIGN.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    campaigns: [
      {
        ...payload,
        category: 'tiktok',
        status: payload.status,
        start_date: payload.startDate,
        end_date: payload.endDate,
        Track: {
          track_name: payload.trackTitle,
          artist_name: payload.trackAutorName,
          track_image: payload.trackCoverUrl,
        },
      },
      ...prevState.campaigns,
    ],
  }),
  [GET_ALL_CAMPAIGNS]: (prevState, { payload }) => ({
    ...prevState,
    campaigns: [...payload],
  }),
  [GET_CAMPAIGNS_LIST.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    campaigns: [...payload],
    loading: false,
    amountOfCampaigns: payload.length,
  }),
  // [GET_CAMPAIGNS_TIKTOK_LIST.SUCCESS]: (prevState, { payload }) => ({
  //   ...prevState,
  // campaigns: [
  //   ...prevState.campaigns,
  //   ...payload.campaigns.map(el => ({
  //     category: 'tiktok',
  //     id: el.id,
  //     status: el.status,
  //     start_date: el.startDate,
  //     end_date: el.endDate,
  //     Track: {
  //       track_name: el.trackTitle,
  //       artist_name: el.trackAutorName,
  //       track_image: el.trackCoverUrl,
  //     },
  //   })),
  // ].reverse(),
  // campaigns: payload.campaigns,
  // loading: false,
  // }),
  [SCHEDULE_CAMPAIGN.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    campaigns: prevState.campaigns.map(item =>
      item.id === payload.id ? payload : item
    ),
  }),
  [CHANGE_CAMPAIGN_GENRE.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    campaigns: prevState.campaigns.map(item =>
      item.id === payload.campaign.id ? payload.campaign : item
    ),
  }),
  [RENEW_CAMPAIGN.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    campaigns: [payload, ...prevState.campaigns],
  }),
  [CHECK_TRACK_TO_CREATE_CAMPAIGN.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    error: payload.errorMessage,
  }),
  [GET_PRESCHEDULE_PRICE.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    preschedule: payload,
  }),
  [GET_ARTIST_SPOTIFY_CONNECTIONS.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    connections: payload.connections,
    sfa_email: payload.sfa_email,
  }),
  [SET_SPOTIFY_CONNECTION_FOR_ARTIST.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    connections: [...prevState.connections, payload.connection],
  }),
  [CREATE_RELAUNCH_CAMPAIGN.SUCCESS]: (prevState, { payload }) => {
    const new_campaigns = [
      {
        id: payload.id,
        type: payload.type,
        trackCoverUrl: payload.Track.track_image,
        trackTitle: payload.Track.track_name,
        trackId: payload.Track.track_id,
        trackAuthorName: payload.Track.artist_name,
        startDate: payload.start_date,
        endDate: payload.end_date,
        status: payload.status,
        platformType: CampaignPlatformTypeEnum.SPOTIFY,
        relaunched: payload.relaunched,
      },
      ...prevState.campaigns,
    ]
    //  eslint-disable-next-line array-callback-return
    new_campaigns.map(campaign => {
      // eslint-disable-next-line no-param-reassign
      if (campaign.trackId === payload.Track.track_id)
        campaign.relaunched = true
    })
    return {
      ...prevState,
      campaigns: new_campaigns,
    }
  },

  [SET_CAMPAIGNS]: (prevState, { payload }) => ({
    ...prevState,
    campaigns: payload,
  }),

  [GET_CAMPAIGN_STATUS.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    campaignToSchedule: payload,
  }),
  [CHANGE_CAMPAIGN.SUCCESS]: (prevState, { payload }) => {
    const campaignToSchedule = {
      ...prevState?.campaignToSchedule,
      payment: prevState?.campaignToSchedule?.payment,
      campaign: {
        ...prevState?.campaignToSchedule?.campaign,
        genres: payload?.genres,
        languages: payload?.languages,
        moods: payload?.moods,
        playlistsCount: payload?.playlistsCount,
        curatorsCount: payload?.curatorsCount,
        minPlaylistsCount: payload?.minCuratorsCount,
        maxPlaylistsCount: payload?.maxPlaylistsCount,
        minCuratorsCount: payload?.minCuratorsCount,
        maxCuratorsCount: payload?.maxCuratorsCount,
        price: payload?.price,
      },
    }
    return {
      ...prevState,
      campaignToSchedule,
    }
  },
}

export default createReducer(initialState, handlers)
